// SPDX-License-Identifier: AGPL-3.0-or-later

import {msg} from '@lingui/core/macro';

export const IN_GAME_OVERLAY_DESCRIPTOR = msg({
	message: 'In-game overlay',
	comment:
		'User settings tab (Windows desktop app) and its on/off switch for the overlay that shows voice channel members on top of a game.',
});
